import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';

import { TipoArquivoSituacaoMultiselectComponent } from './multiselect';
import { TipoArquivoSituacaoPipe } from './pipes';
import { TipoArquivoSituacaoBadgeComponent } from './badge';

@NgModule({
    imports: [
        SharedModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        TipoArquivoSituacaoMultiselectComponent,
        TipoArquivoSituacaoBadgeComponent,

        // Pipes
        TipoArquivoSituacaoPipe
    ],
    exports: [
        TipoArquivoSituacaoMultiselectComponent,
        TipoArquivoSituacaoBadgeComponent,

        // Pipes
        TipoArquivoSituacaoPipe
    ],
    providers: [
        // Pipes
        TipoArquivoSituacaoPipe
    ]
})
export class TipoArquivoSituacaoModule { }
